import {Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";
import {ActivatedRoute, Router} from "@angular/router";
import {Acesso} from "src/app/core/acesso";
import {CarregarPerfil} from "src/app/core/carregar-perfil";
import {Eixo} from "src/app/core/eixo";
import {ConfirmDialogComponent} from "../common/confirm-dialog/confirm-dialog.component";
import {EixoService} from "../../services/eixo/eixo.service";

@Component({
    selector: "eixo",
    templateUrl: "./eixo.component.html",
    styleUrls: ["./eixo.component.css"],
})
export class EixoComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    listaEixo: Eixo[];
    nomeFiltro: string = null;
    descricaoFiltro: string = null;
    msg: string;

    mostrarTabela = false;

    displayedColumns: string[] = ["nome", "descricao", "acoes"];
    dataSource: MatTableDataSource<Eixo> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    constructor(
        private eixoService: EixoService,
        private router: Router,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );
        this.dataSource.paginator = this.paginator;
        this.getAll();
    }

    limpar() {
        this.mostrarTabela = false;
        this.nomeFiltro = null;
        this.descricaoFiltro = null;
        this.dataSource.data = [];
    }

    consultar() {
        if (this.nomeFiltro != null || this.descricaoFiltro != null) {
            this.eixoService
                .getByFilter(this.nomeFiltro, this.descricaoFiltro)
                .subscribe((eixo: Eixo[]) => {
                    if (!eixo) {
                        this.mostrarTabela = false;
                        this.msg = "Nenhum registro para a pesquisa selecionada";
                    } else {
                        this.dataSource.data = eixo;
                        this.mostrarTabela = true;
                    }
                });
        } else {
            this.getAll();
        }
    }

    atualizar(eixo: Eixo) {
        this.router.navigate(["/eixo/cadastrar"], {
            queryParams: {id: eixo.id},
        });
    }

    deletar(eixo: Eixo) {
        this.chamaCaixaDialogo(eixo);
    }

    chamaCaixaDialogo(eixo: Eixo) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Certeza que deseja excluir?`,
            textoConfirma: "SIM",
            textoCancela: "NÃO",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.eixoService.excluir(eixo.id).subscribe(() => {
                    this.nomeFiltro = null;
                    this.descricaoFiltro = null;
                    this.consultar();
                });
            } else {
                dialogRef.close();
            }
        });
    }

    getAll() {
        this.eixoService
            .getAll()
            .subscribe((listaEixo: Eixo[]) => {
                this.listaEixo = listaEixo;
                this.dataSource.data = listaEixo ? listaEixo : [];
                this.verificaMostrarTabela(listaEixo);
            });
    }

    verificaMostrarTabela(listaEixo: Eixo[]) {
        if (!listaEixo || listaEixo.length == 0) {
            this.mostrarTabela = false;
            this.msg = "Nenhum cadastro.";
        } else {
            this.mostrarTabela = true;
        }
    }
}
